module.exports = __webpack_public_path__ + "static/media/annotation_icon.6974ca07.svg";